import React from "react";

const Promo = () => {
  return (
    <div className="mb-14 bg-[#BDB1A5]">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F12_SecondBanner.jpg?alt=media&token=2e58c32b-448d-4b45-a16f-c5e6045c36a2"
        className=" w-full h-56 object-contain"
        alt=""
      />
    </div>
  );
};

export default Promo;
